module.exports = __webpack_public_path__ + "img/category-title03.727a8930.png";